export const useRecoveryPhraseProtected=()=>{};